import { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login.jsx';
import Command from './pages/Command.jsx';
import ApprovalQueue from './pages/ApprovalQueue.jsx';
import AddProspect from './pages/AddProspect.jsx';
import Prospects from './pages/Prospects.jsx';
import ProspectDetail from './pages/ProspectDetail.jsx';
import EditProspect from './pages/EditProspect.jsx';
import EditPitch from './pages/EditPitch.jsx';

function useSession() {
  const [state, setState] = useState({ loading: true, authed: false });

  useEffect(() => {
    fetch('/api/me', { credentials: 'include' })
      .then(r => setState({ loading: false, authed: r.ok }))
      .catch(() => setState({ loading: false, authed: false }));
  }, []);

  return state;
}

function Protected({ children }) {
  const { loading, authed } = useSession();
  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', background: 'var(--bg-soft)' }}>
        <div className="row muted"><span className="spinner" /> Loading</div>
      </div>
    );
  }
  if (!authed) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<Protected><Command /></Protected>} />
      <Route path="/queue" element={<Protected><ApprovalQueue /></Protected>} />
      <Route path="/prospects" element={<Protected><Prospects /></Protected>} />
      <Route path="/prospects/new" element={<Protected><AddProspect /></Protected>} />
      <Route path="/prospects/:id" element={<Protected><ProspectDetail /></Protected>} />
      <Route path="/prospects/:id/edit" element={<Protected><EditProspect /></Protected>} />
      <Route path="/pitches/:id/edit" element={<Protected><EditPitch /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
